import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wrong-route',
  templateUrl: './wrong-route.component.html',
  styleUrls: ['./wrong-route.component.scss']
})
export class WrongRouteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
